import React, { useCallback, useContext, useEffect, useState } from 'react';
import Constants from 'expo-constants';
import { PERSISTENCE_KEY, ActionTypes, AuthContext, AuthReducer, initialState, logout as commonLogout, refreshToken } from './common';
import AppContext, { AppActions, AppStatus } from '../App';
import { fetch } from '../../common/Api';
import usePersistedState from '../../hooks/usePersistedState';

const AuthContextProvider = props => {
    const { state: appState, dispatch: appDispatch } = useContext(AppContext);
    const [initialized, setInitialized] = useState(false);
    const { state, dispatch, remove } = usePersistedState(PERSISTENCE_KEY, initialState, AuthReducer);
    const enabled = Constants.expoConfig.extra?.enableAuth?.toBoolean();
    
    const logout = useCallback(async () => {
        dispatch({
            type: ActionTypes.USER_LOGOUT,
            data: {
                user: {
                    ...state.user,
                    loggedIn: false,
                    tid: undefined,
                    refreshToken: undefined,
                    accessToken: undefined
                }
            }
        });

        try {
            remove();

            await commonLogout(
                        appState.authority?.revocation_endpoint, 
                        appState.settings.openIdSettings.thisClient.id, 
                        appState.settings.openIdSettings.thisClient.secret, 
                        state.user.accessToken, 
                        state.user.refreshToken
            );

            appDispatch({
                type: AppActions.USER_LOGOUT,
                status: AppStatus.USER_LOGOUT_SUCCESS
            });
        } catch(e) {
            appDispatch({
                type: AppActions.USER_LOGOUT,
                status: AppStatus.USER_LOGOUT_FAILED
            });
        }
    }, []);

    useEffect(() => {
        const init = async () => {
            const endpoint = `${appState.settings.openIdSettings.authority}/.well-known/openid-configuration`;
            const response = await fetch(endpoint);

            if (response) {
                state.authority = response;
            }

            setInitialized(true);
        };

        if (enabled && appState.settings?.openIdSettings) {
            init();
        }
    }, []);

    // useEffect(() => {
    //     const updateUserToken = async() => {
    //         const now = Date.now();
    //         const accessTokenExpired = Math.floor((state.user.tokenExpires * 60) + state.user.tokenCreated) < now;

    //         if (state.user?.loggedIn && accessTokenExpired) {
    //             await refreshToken(state.authority.token_endpoint, 
    //                                state.user.refreshToken, 
    //                                appState.settings.openIdSettings.thisClient.id, 
    //                                appState.settings.openIdSettings.thisClient.secret);
    //         }
    //     };

    //     (async () => await updateUserToken()) ();

    // }, [ state.user?.loggedIn ]);

    return <AuthContext.Provider value={{ state, dispatch, logout }}>{props.children}</AuthContext.Provider>;
};

export { ActionTypes, AuthContextProvider };

export default AuthContext;
